import { useState } from 'react';
import PropTypes from 'prop-types';

import MoneyInput from '../inputs/MoneyInput';
import HorizontalDivider from '../common/HorizontalDivider';

const TipSelector = ({ tipAmount, setTipAmount }) => {
  const [isCustomValue, setIsCustomValue] = useState(false);

  const tipOptions = [5, 15, 25]; // used as key, make sure no duplicates

  const handleTipButtonClick = (tipOption) => {
    setIsCustomValue(false);
    // If the tip amount displayed on the button is selected, unselect it
    if (tipAmount === tipOption) {
      setTipAmount(0);
    } else {
      setTipAmount(tipOption);
    }
  };

  return (
    <div className="flex flex-col gap-8 rounded-lg py-10">
      <div className="mx-auto flex max-w-screen-xxxs items-end justify-between gap-3 xxxs:gap-4 xxs:gap-6 xs:gap-8">
        {tipOptions.map((tipOption, idx) => {
          const isSelected = tipAmount === tipOption;

          const bgColor = isSelected
            ? 'bg-pj-primary-400 text-pj-good-contrast'
            : 'bg-pj-gray-500';
          const textStyle = isSelected
            ? 'text-payjim-white font-semibold'
            : 'text-black';

          return (
            <div key={tipOption}>
              <input
                className="hidden"
                type="radio"
                id={`${tipOption}`}
                name="tip"
                onClick={() => handleTipButtonClick(tipOption)}
              />
              <label
                style={{
                  paddingTop: `${22 + 16 * idx}px`,
                  paddingBottom: `${22 + 16 * idx}px`,
                }}
                className={`block rounded-lg px-7 font-bold xxxs:px-10 ${bgColor} ${textStyle}`}
                htmlFor={`${tipOption}`}
              >
                {`${tipOption}€`}
              </label>
            </div>
          );
        })}
      </div>

      <HorizontalDivider text="or" />

      <MoneyInput
        id="customTipAmount"
        label="Enter Individual Amount"
        value={isCustomValue ? tipAmount : 0}
        onChange={(num) => {
          setIsCustomValue(true);
          setTipAmount(num);
        }}
      />
    </div>
  );
};

TipSelector.propTypes = {
  tipAmount: PropTypes.number.isRequired,
  setTipAmount: PropTypes.func.isRequired,
};

export default TipSelector;
